<template>
  <div>
    <div>
      <h2>Selite:</h2>
      <CRow class="box-row">
        <div class="explainer">Projektin tarkastuspiste</div>
        <div class="explainer">Tehtävä</div>
        <div class="explainer">Alitehtävä</div>
      </CRow>

      <CRow class="ball-row">
        <div class="explainer-ball first"></div>
        <p>Tilaajan tehtävä</p>
      </CRow>
      <CRow class="ball-row">
        <div class="explainer-ball second"></div>
        <p>Laitetoimittajan tehtävä</p>
        <p style="width: 100%; padding: 0; margin-top: 0.5rem">
          Jos molemmat, päävastuu ensimmäisellä / kuten sovittu
        </p>
      </CRow>
      <CRow class="ball-row">
        <div class="explainer-ball third"></div>
        <p>Kuten toimijoiden kesken sovitaan</p>
      </CRow>
    </div>
    <div class="button-wrapper">
      <button class="toggle-button parents-toggle" @click="handleParentToggle">
        {{ parentsOpen ? "Sulje kaikki" : "Avaa kaikki" }}
      </button>
    </div>
    <div v-bind:key="`group-${index}`" v-for="(main, index) in jsonData.data">
      <Parent :main="main" :main-index="index" />
    </div>
  </div>
</template>

<script lang="ts">
import jsonData from "./data.json";
import { defineComponent } from "vue";
import Parent from "@/components/Parent.vue";
import { emitter } from "@/events";

export default defineComponent({
  name: "App",
  components: { Parent },
  data() {
    return {
      jsonData,
      tasksOpen: false,
      parentsOpen: false,
    };
  },
  methods: {
    handleTasksToggle() {
      this.tasksOpen = !this.tasksOpen;
      emitter.emit("global-handle", { open: this.tasksOpen });
    },
    handleParentToggle() {
      this.parentsOpen = !this.parentsOpen;
      this.tasksOpen = this.parentsOpen;
      emitter.emit("global-parent-handle", { open: this.parentsOpen });
      emitter.emit("global-handle", { open: this.tasksOpen });
    },
  },
});
</script>

<style lang="scss">
#app {
  font-family: "Raleway", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;

  .button-wrapper {
    .toggle-button {
      color: #fff;
      background-color: #2d594a;
      text-transform: uppercase;
      border: 2px solid #2d594a;
      font-weight: 700;
      letter-spacing: 1.8px;
      padding: 0.5rem 3rem;
      width: auto;
      display: block;
      &:first-child {
        margin-bottom: 1rem;
      }
      &.parents-toggle {
        background-color: #fbbc6b;
        color: #000;
        border: 2px solid #fbbc6b;
      }
    }
  }

  .box-row {
    margin-bottom: 1rem;
  }

  .explainer {
    width: auto;
    padding: 1rem 2rem;
    margin: 0 0.5rem 0.5rem;
    font-size: 1.25rem;
    &:nth-child(1) {
      background-color: #fbbc6b;
      color: #000;
    }
    &:nth-child(2) {
      background-color: #2d594a;
      color: #fff;
    }
    &:nth-child(3) {
      background-color: #0f7b99;
      color: #fff;
    }
  }

  .ball-row {
    flex-direction: row;
    align-items: center;
    padding: 0 1.5rem;
    margin-bottom: 1.5rem;

    .explainer-ball {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      &.first {
        background-color: #80ffd4;
      }
      &.second {
        background-color: #cc5279;
      }
      &.third {
        background-color: #52b2cc;
      }
    }

    p {
      width: auto;
      margin-bottom: 0;
      font-size: 1.25rem;
    }
  }
}
</style>
